export default function Hero() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-blue-900 leading-tight mb-6">
              ICM – Instituto de Clínica Médica
            </h1>
            <p className="text-xl text-gray-700 mb-8">
              Atención integral en medicina interna en Mar del Plata
            </p>
            <p className="text-base text-gray-600 mb-10 leading-relaxed">
              Brindamos atención médica profesional con enfoque en la prevención y el seguimiento continuo de nuestros pacientes.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="tel:+542234515475" 
                className="inline-flex items-center justify-center gap-2 bg-blue-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl"></i>
                Llamar para Turno
              </a>
              <a 
                href="https://wa.me/5492235470285" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-green-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
            </div>

            <div className="mt-10 flex items-center gap-6">
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-2xl text-blue-600"></i>
                <div>
                  <p className="text-sm font-semibold text-gray-900">Horario de Verano</p>
                  <p className="text-sm text-gray-600">Lun - Vie: 9:00 - 15:00</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-line text-2xl text-blue-600"></i>
                <div>
                  <p className="text-sm font-semibold text-gray-900">Ubicación</p>
                  <p className="text-sm text-gray-600">Rawson 1006</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/6084b339fc3a78c83811e4e1149e506c/1143c9b0d73d3fad610a1eb649ac4ef3.jpeg" 
                alt="Instituto de Clínica Médica" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-lg p-6 max-w-xs">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-900">Atención Profesional</p>
                  <p className="text-xs text-gray-600">Más de 30 años de experiencia</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}